<template>
  <div class="card">
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Card',

}
</script>

<style scoped>

.card {
  border-radius: 5px;
  /* box-shadow: 0 2px 5px #ccc; */
  text-align: center;
  padding: 15px 10px;
  display: block;
  margin: 20px;
  color: #212529;
  border: none;
  min-height: 100px;
  background: #f0f0f0;
}

</style>
